import { useMemo } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { productByHandleQueryOptions } from "@/lib/shopify-queries";
import type { Product } from "@/lib/fragrance-data";
import { buildProductCopy, type ProductCopy } from "@/lib/shopify-product-copy";

export function useLiveProduct(local: Product) {
  // Keyed by canonical URL slug — alias resolution happens inside the loader.
  const { data: liveProduct } = useSuspenseQuery(
    productByHandleQueryOptions(local.slug),
  );

  const copy: ProductCopy = useMemo(
    () => buildProductCopy(local, liveProduct ?? null),
    [local, liveProduct],
  );

  return { liveProduct: liveProduct ?? null, copy, isLoading: false, hasShopify: true };
}

